import { APIReferenceMemberWithParameters } from '@modules/client';
import React, { FC } from 'react';
import { Typography } from '@rbx/ui';
import ReferenceMemberParameterItem from './ReferenceMemberParameterItem';
import useReferenceSummaryMemberTableStyles from './ReferenceSummaryMemberTable.styles';

interface ReferenceMemberParametersProps {
  parameters: APIReferenceMemberWithParameters['parameters'];
}

const ReferenceMemberParameters: FC<React.PropsWithChildren<ReferenceMemberParametersProps>> = ({
  parameters,
}) => {
  const {
    classes: { parameters: parametersStyle },
  } = useReferenceSummaryMemberTableStyles();
  return (
    <Typography className={parametersStyle} component='span' variant='smallLabel2'>
      <React.Fragment>
        (
        {(parameters || []).map((param, i) => (
          <ReferenceMemberParameterItem
            key={param.name}
            parameter={param}
            isLast={i === (parameters || []).length - 1}
          />
        ))}
        )
      </React.Fragment>
    </Typography>
  );
};

export default ReferenceMemberParameters;
